import openvpn from "./openvpn.json";
import pptp from "./pptp.json";
import l2tp from "./l2tp.json";

export default { openvpn, l2tp, pptp };
